/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Progress_TitleInputs */

const en_portal_view_progress_title = /** @type {(inputs: Portal_View_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

const pl_portal_view_progress_title = /** @type {(inputs: Portal_View_Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postępy`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {Portal_View_Progress_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_progress_title = /** @type {((inputs?: Portal_View_Progress_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Progress_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_progress_title(inputs)
	return en_portal_view_progress_title(inputs)
});